import React, { useRef, useState, useEffect } from 'react';

const InvoiceCanvasDesigner = () => {
  const canvasRef = useRef(null);
  const [items] = useState([
    { id: 1, barcode: '000001', description: 'A One 2025 0.1 New black', qty: 1, price: 22, disc: 0, amount: 22 }
  ]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.font = '20px Arial';
    ctx.fillText('Quotation', 350, 40);

    ctx.font = '14px Arial';
    ctx.fillText('Date: 22/04/2025', 20, 70);
    ctx.fillText('Time: 10:16:44 AM', 600, 70);
    ctx.fillText('Account No: 101', 20, 100);

    // Table Headers
    ctx.font = 'bold 14px Arial';
    const headers = ['Item', 'Barcode', 'Product Description', 'Qty', 'Price', 'Disc', 'Amount'];
    let xPositions = [20, 70, 160, 420, 470, 530, 600];
    headers.forEach((header, i) => {
      ctx.fillText(header, xPositions[i], 140);
    });

    ctx.font = '14px Arial';
    let yStart = 170;
    items.forEach((item, index) => {
      ctx.fillText(`${index + 1}`, xPositions[0], yStart);
      ctx.fillText(item.barcode, xPositions[1], yStart);
      ctx.fillText(item.description, xPositions[2], yStart);
      ctx.fillText(`${item.qty}`, xPositions[3], yStart);
      ctx.fillText(`RS${item.price.toFixed(2)}`, xPositions[4], yStart);
      ctx.fillText(`RS${item.disc.toFixed(2)}`, xPositions[5], yStart);
      ctx.fillText(`RS${item.amount.toFixed(2)}`, xPositions[6], yStart);
      yStart += 30;
    });

    // Subtotal & Total
    ctx.fillText(`Subtotal ${items.length}`, 20, yStart + 20);
    ctx.fillText(`RS0.00`, 530, yStart + 20);
    ctx.fillText(`RS${items.reduce((sum, item) => sum + item.amount, 0).toFixed(2)}`, 600, yStart + 20);

    ctx.font = 'bold 16px Arial';
    ctx.fillText(`Total RS ${items.reduce((sum, item) => sum + item.amount, 0).toFixed(2)}`, 500, yStart + 60);
  }, [items]);

  const exportInvoice = () => {
    const canvas = canvasRef.current;
    const imgData = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = imgData;
    link.download = 'invoice.png';
    link.click();
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={exportInvoice}
        style={{ margin: '8px', padding: '8px', backgroundColor: '#10b981', color: 'white', borderRadius: '4px', border: 'none' }}
      >
        Export Invoice
      </button>
      <div style={{ position: 'relative', border: '1px solid #ccc', marginTop: '16px' }}>
        <canvas ref={canvasRef} width={800} height={1000} style={{ border: '1px solid #ccc' }} />
      </div>
    </div>
  );
};

export default InvoiceCanvasDesigner;